var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertydamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3126 133.608C18.6696 122.34 17.1769 106.339 24.6725 95.7477C32.233 85.0594 45.764 84.3833 47.5162 84.319C53.0324 82.3551 59.7817 78.846 62.9292 72.2141C66.7256 64.1657 61.8259 58.6927 64.6165 51.0628C69.646 37.2517 93.171 34.4831 95.2477 34.2577C111.861 32.5192 133.959 38.958 139.085 52.7369C142.849 62.8457 134.802 69.6386 140.286 80.7776C144.018 88.3754 149.372 88.4719 154.661 95.5546C161.832 105.116 166.375 120.762 159.755 129.326C157.711 131.966 155.018 133.382 153.136 134.123",
    fill: "#ECF2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 132.5H150",
    stroke: "#C9D4E2",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 132.5V84L90 61L123 84V132.5",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 132.5V84L90 61L123 84V132.5",
    stroke: "#8C9BAE",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L90 58L132 88",
    stroke: "#8C9BAE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79 132.5V107H101V132.5",
    fill: "#ECF2F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79 132.5V107H101V132.5",
    stroke: "#8C9BAE",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72L88 92H101L90 114",
    stroke: "#E2574C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123 84L137 74",
    stroke: "#8C9BAE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133 95L145 90",
    stroke: "#C9D4E2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57 84L43 74",
    stroke: "#8C9BAE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95L35 90",
    stroke: "#C9D4E2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertydamage);
export default __webpack_public_path__ + "static/media/propertydamage.7191ef9a1c024f668b951e37449c1344.svg";
export { ForwardRef as ReactComponent };